
import React from 'react';
import {Button, Container, Nav, Navbar } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import './Menubar.css'

const Menubar = () => {
    const history =useHistory()
    const logoClick=()=>{
        history.push('/')
    }
    return (
        <Container className="p-0 menubar-container">
            <Navbar expand="lg">
                <Navbar.Brand >
                    <img onClick={logoClick} src={'https://i.ibb.co/Gs1JM7X/logo.png'} className="logo" alt="" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto menu-links">
                        <Link className="menu-link" to="/">Home</Link>
                        <Link className="menu-link" to="/projects">Projects</Link>
                        <Link className="menu-link" to="/aboutme">About</Link>
                        <Link className="menu-link" to="/blogs">Blogs</Link>
                        <Link className="menu-link" to="/contactme">Contact</Link>
                        <Button className="menu-Resume" target="_blank" href="https://drive.google.com/file/d/1_g6Ab0KTMDQuT4hTUJ5IfZiaQLmzEEaB/view?usp=sharing">Resume</Button>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </Container>
    );
};

export default Menubar;